module.exports = __webpack_public_path__ + "static/img/invite-order.83f71d54.png";